import React, { useState, useEffect, useRef } from 'react';
import { Helmet } from 'react-helmet';
import { message, Spin, Carousel, ConfigProvider, Button, Dropdown } from 'antd';
import { LeftOutlined, RightOutlined, CloudDownloadOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import '../styles/Dashboard.css';
import avatar from '../uploads/avatar.png';
import NavBar from '../components/CV/NavBar';
import { API_URL, API_username, API_password } from '../utils/api';
import PersonalInfo from '../components/Form2Print/PersonalInfo';
import EducationInfo from '../components/Form2Print/EducationInfo';
import EmploymentInfo from '../components/Form2Print/EmploymentInfo';
import RelativesInfo from '../components/Form2Print/RelativesInfo';
import AdditionalInfo from '../components/Form2Print/AdditionalInfo';
import Disclaimer from '../components/Form2Print/Disclaimer';
import logo from '../uploads/logo.png';
import Template1 from './Template1';
import Docxtemplater from "docxtemplater";
import PizZip from "pizzip";
import PizZipUtils from "pizzip/utils/index.js";
import { saveAs } from "file-saver";
import template from '../templates/emp_template1.docx';
import ImageModule from 'docxtemplater-image-module-free';
import { CloseOutlined, RotateRightOutlined, RotateLeftOutlined, VerticalAlignMiddleOutlined } from '@ant-design/icons';
import { CustomCropper } from '../services/CustomCropper';

function loadFile(url, callback) {
	PizZipUtils.getBinaryContent(url, callback);
}

function CV() {
	useEffect(() => {
        getinfo();
		// const handleClick = (event) => {
		// console.log(event.target);
		// };
	
		// document.addEventListener('click', handleClick);
	
		// return () => {
		// document.removeEventListener('click', handleClick);
		// };
	}, []);
	const navigate = useNavigate();
	const [loading, setLoading] = useState(true);
	const [open, setOpen] = useState(false);
	const [slideIndex, setSlideIndex] = useState(1);
    let sliderRef = useRef();
	const shortInfo = localStorage.getItem('shortinfo') !== null ? JSON.parse(localStorage.getItem('shortinfo')) : avatar;
    const targetRef = useRef();

	const [photo, setPhoto] = useState('');
	const [isPhotoUploaded, setIsPhotoUploaded] = useState(false);
    
	const next = () => {
        sliderRef.next();
        if(slideIndex < 2) setSlideIndex(slideIndex+1);
    };
    const previous = () => {
        sliderRef.prev();
        if(slideIndex > 1) setSlideIndex(slideIndex-1);
    };
	
	const generateDocument = () => {
		const imageUrl = formData.Photo ? `data:image/jpeg;base64, ${formData.Photo}` : avatar;
		const birthPlace = `${formData.BirthPlace.Country.Name ? formData.BirthPlace.Country.Name : ''}${formData.BirthPlace.City ? `, ${formData.BirthPlace.City}` : ''}`;
		var opts = {}
		opts.centered = false;
		opts.fileType = "docx";
		opts.getImage = function() {
			const binaryData = atob(formData.Photo);
			const byteArray = new Uint8Array(binaryData.length);
			for (let i = 0; i < binaryData.length; i++) {
				byteArray[i] = binaryData.charCodeAt(i);
			}
			return byteArray.buffer;
		}
		opts.getSize = function(img, tagValue, tagName) {
			return [120, 150];
		}
		var imageModule = new ImageModule(opts);
		loadFile(template, function (error, content) {
		  if (error) {
			throw error;
		  }
		  var zip = new PizZip(content);
		  var doc = new Docxtemplater(zip, {
			modules: [imageModule],
			paragraphLoop: true,
			linebreaks: true
		  });
		  doc.setData({
			avatar: formData.Photo,
			name: formData.Name,
			birthDate: formData.BirthDate,
			mobilephone: formData.MobilePhonePersonal.value,
			passport: `${formData.Passport.DocSeries} ${formData.Passport.DocNumber}`,
			birthPlace: birthPlace,
			email: formData.EmailPersonal,
			maritalStatus: formData.MaritalStatus.Name,
			employmentData: employmentData,
			// educationData: educationData,
			// languageData: languageData
		  });
		//   console.log(imageUrl);
		  try {
			doc.render();
		  } catch (error) {
			function replaceErrors(key, value) {
			  if (value instanceof Error) {
				return Object.getOwnPropertyNames(value).reduce(function (
				  error,
				  key
				) {
				  error[key] = value[key];
				  return error;
				},
				{});
			  }
			  return value;
			}
			console.log(JSON.stringify({ error: error }, replaceErrors));
	
			if (error.properties && error.properties.errors instanceof Array) {
			  const errorMessages = error.properties.errors
				.map(function (error) {
				  return error.properties.explanation;
				})
				.join("\n");
			  console.log("errorMessages", errorMessages);
			}
			throw error;
		  }
		  var out = doc.getZip().generate({
			type: "blob",
			mimeType:
			  "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
		  }); //Output the document using Data-URI
		  saveAs(out, `CV_${shortInfo.Name.replace(/ /g, '_')}`);
		});
	  };
	

    const handleDownloadClick = (FileExtension) => {
		// generateDocument();
		setLoading(true);
        let apiUrl = `${API_URL}/lk?method=getmaketbyname&inbody=1`;
		let sessionId = localStorage.getItem("SessionId")
		fetch(apiUrl, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Basic ' + btoa(`${API_username}:${API_password}`),
				'sessionid': sessionId
			}, 
			body: JSON.stringify({
				MaketName: `EmployeeForm${slideIndex}`,
				ThisEmployee: true,
				FileExtension: FileExtension,
				Photo: photo,
				IsPhotoUploaded: isPhotoUploaded
			})
		})
		.then(response => {
			if (response.status === 200) {
				return response.json();
			} else if (response.status === 202) {
				message.error('Сервер на данный момент перегружен!');
				return "error";
			} else if (response.status === 404) {
				message.error('Сессия не найдена, авторизуйтесь заново!');
				navigate('/logout');
				return "error";
			} else {
				message.error('Произошла ошибка при отправке запроса!');
				return "error";
			}
		})
		.then(data => {
			if (data === "error") {

			} else {
				if(FileExtension === 'PDF') {
					const base64String = data.ResumeFile; // Получаем Base64 строку из ответа
					const binaryData = atob(base64String); // Преобразуем Base64 строку в бинарные данные
					const arrayBuffer = new ArrayBuffer(binaryData.length);
					const uint8Array = new Uint8Array(arrayBuffer);
	
					for (let i = 0; i < binaryData.length; i++) {
						uint8Array[i] = binaryData.charCodeAt(i);
					}
	
					const blob = new Blob([uint8Array], { type: 'application/pdf' }); // Создаем объект Blob
					const url = window.URL.createObjectURL(blob); // Создаем URL для Blob
					const a = document.createElement('a'); // Создаем элемент ссылки
					a.href = url;
					a.download = `CV_${shortInfo.Name.replace(/ /g, '_')}.pdf`; // Указываем имя файла для скачивания
					a.click(); 
				} else if(FileExtension === 'DOCX') {
					const base64String = data.ResumeFile;
					const binaryData = atob(base64String);
					const arrayBuffer = new ArrayBuffer(binaryData.length);
					const uint8Array = new Uint8Array(arrayBuffer);

					for (let i = 0; i < binaryData.length; i++) {
						uint8Array[i] = binaryData.charCodeAt(i);
					}

					const blob = new Blob([uint8Array], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
					const url = window.URL.createObjectURL(blob);
					const a = document.createElement('a');
					a.href = url;
					a.download = `CV_${shortInfo.Name.replace(/ /g, '_')}.docx`;
					a.click();
				}
			}
		})
		.catch(error => {
			message.error('Ошибка: ' + error.message);
		}).finally(() => {
			setLoading(false);
		});
    }

    const [formData, setFormData] = useState({
		Name: '',
		AnalogName: '',
		BirthDate: '',
		BirthPlace: {
			SpecialBirthPlace: 0,
			City: "",
			District: "",
			Region: "",
			Country: {
				Name: "",
				UID: ""
			}
		},
		Nationality: {
			Name: "",
			UID: ""
		},
		Citizenship: {
			Name: "",
			UID: ""
		},
		Passport: {
			type: {
				Name: "",
				UID: ""
			},
			DocSeries: '',
			DocNumber: '',
			DocIssued: '',
			DocDateIssued: '',
			departmentCode: '',
			DocValid: '',
			DocInfoValid: ''			
		},
		MaritalStatus: {
			Name: "",
			UID: ""
		},
		EmailWork: '',
		EmailPersonal: '',
		INN: '',
		INPS: '',
		Sex: {
			Name: "",
			UID: ""
		},
		Photo: null,
		MobilePhoneWork: {
			countryCode: '',
			areaCode: '',
			number: '',
			extNumber: '',
			value: '',
			comment: ''
		},
		HomePhoneNumber: {
			countryCode: '',
			areaCode: '',
			number: '',
			extNumber: '',
			value: '',
			comment: ''
		},
		MobilePhonePersonal: {
			countryCode: '',
			areaCode: '',
			number: '',
			extNumber: '',
			value: '',
			comment: ''
		},
		WorkPhoneNumber: {
			countryCode: '',
			areaCode: '',
			number: '',
			extNumber: '',
			value: '',
			comment: ''
		},
	});

	const [educationData, setEducationData] = useState([
		{
			Start: '',
			End: '',
			EducationType: {
				Name: '',
				UID: ''
			},
			EducationKind: {
				Name: '',
				UID: ''
			},
			Institution: {
				Name: '',
				UID: ''
			},
			Faculty: '',
			Speciality: {
				Name: '',
				UID: ''
			},
			DocTypeEducation: {
				Name: '',
				UID: ''
			},
			DocSeries: '',
			DocNumber: '',
			DocDateIssued: ''
		}
	]);

	const [languageData, setLanguageData] = useState([
		{
			Language: {
				Name: '',
				UID: ''
			},
			LanguageDegree: {
				Name: '',
				UID: ''
			}
		}
	]);

	const [computerSkillsData, setComputerSkillsData] = useState([
		{
			Software: {
				Name: '',
				UID: ''
			},
			SoftwareLevel: {
				Name: '',
				UID: ''
			}
		}
	]);

	const [employmentData, setEmploymentData] = useState([
		{
			EmploymentDate: '',
			DismissalDate: '',
			Organization: '',
			Departament: '',
			Division: '',
			Position: '',
			Address: '',
			Duties: '',
			ActivityProfile: '',
			Country: {
				Name: '',
				UID: ''
			},
			City: '',
			EmploymentType: {
				Name: '',
				UID: ''
			}
		}
	]);

	const [relativesData, setRelativesData] = useState([
		{
			RelationshipDegree: {
				Name: '',
				UID: ''
			},
			Name: '',
			BirthDate: '',
			BirthPlace_Country: {
				Name: '',
				UID: ''
			},
			Position: '',
			ResidencePlace: '',
			WorkPlace: '',
			Dependent: '',
			IsDisabled: ''
		}
	]);

	const [RegistrationAddress, setRegistrationAddress] = useState({
		AddressType: "",
		Country: {
			Name: "",
			UID: ""
		},
		City: {
			Subject: "",
			Area: "",
			MunicipalDistrict: "",
			City: "",
			Village: "",
			IntracityDistrict: "",
			PopulationPoint: "",
			Territory: "",
		},
		Street: "",
		HouseType: "",
		TypeBuilding: "",
		TypePremises: "",
		House: "",
		Building: "",
		Premises: "",
		Index: "",
		ViewAddresses: ""
	});

	const [ResidenceAddress, setResidentialAddress] = useState({
		AddressType: "",
		Country: {
			Name: "",
			UID: ""
		},
		City: {
			Subject: "",
			Area: "",
			MunicipalDistrict: "",
			City: "",
			Village: "",
			IntracityDistrict: "",
			PopulationPoint: "",
			Territory: "",
		},
		Street: "",
		HouseType: "",
		TypeBuilding: "",
		TypePremises: "",
		House: "",
		Building: "",
		Premises: "",
		Index: "",
		ViewAddresses: ""
	});
	const [ShiftMode, setShiftWorkReady] = useState('Да');
	const [Prosecution, setLegalIssues] = useState('Да');

	const [showPhotoCropperModal, setShowPhotoCropperModal] = useState(false);
	const cropperRef = useRef(null);
    const [image, setImage] = useState(null);

    const getinfo = () => {
		let apiUrl = `${API_URL}/lk?method=getinfo&inbody=0`;
		let sessionId = localStorage.getItem("SessionId")
		fetch(apiUrl, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Basic ' + btoa(`${API_username}:${API_password}`),
				'sessionid': sessionId
			}
		})
		.then(response => {
			if (response.status === 200) {
				return response.json();
			} else if (response.status === 202) {
				message.error('Сервер на данный момент перегружен!');
				return "error";
			} else if (response.status === 404) {
				message.error('Сессия не найдена, авторизуйтесь заново!');
				navigate('/logout');
				return "error";
			} else {
				message.error('Произошла ошибка при отправке запроса!');
				return "error";
			}
		})
		.then(data => {
			if (data === "error") {

			} else {
				setFormData(prevState => {
					const updatedFormData = { ...prevState };
					processFormData(data, updatedFormData);
					return updatedFormData;
				});
				setEducationData(data.Education);
				setLanguageData(data.Languages);
				setComputerSkillsData(data.ComputerSkills);
				setEmploymentData(data.LaborActivity);
				setRelativesData(data.Family);
				setRegistrationAddress(data.RegistrationAddress);
				setResidentialAddress(data.ResidenceAddress);
				setShiftWorkReady(data.ShiftMode);
				setLegalIssues(data.Prosecution);
				const shortInfo = JSON.parse(localStorage.getItem('shortinfo'));
				shortInfo.Photo = data.Photo;
				localStorage.setItem('shortinfo', JSON.stringify(shortInfo));
			}
		})
		.catch(error => {
			message.error('Ошибка: ' + error.message);
		}).finally(() => {
			setLoading(false);
			setOpen(true);
		});
	};

	const formatDate = (date) => {
		const rawDate = date.split('T')[0];
        const dateParts = rawDate.split('-');
        return `${dateParts[2]}.${dateParts[1]}.${dateParts[0]}`;
	};

	const processFormData = (data, formData) => {
		for (const key in data) {
			if (formData.hasOwnProperty(key)) {
				// Если значение является объектом, вызываем processFormData рекурсивно
				if (typeof data[key] === 'object' && data[key] !== null) {
					formData[key] = processFormData(data[key], formData[key] || {});
				} else {
					// Обработка даты рождения и других полей, если необходимо
					if (key === "BirthDate" || key === "DocDateIssued" || key === "DocValid" || key === "DocInfoValid" || key === "Start" || key === "End" || key === "DocDateIssued") {
						formData[key] = formatDate(data[key]);
					} else {
						// Присваиваем другие значения как есть
						formData[key] = data[key];
					}
				}
			}
		}
		return formData;
	};

	const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => setImage(reader.result);
      reader.readAsDataURL(file);
    }
  };

    const handleCropImage = () => {
        const base64String = cropperRef.current.getCanvas().toDataURL().split(',')[1];
        if (cropperRef.current) {
        const croppedImage = base64String;
        setFormData((prevState) => ({
            ...prevState,
            Photo: croppedImage,
        }));
        setPhoto(croppedImage);
        setIsPhotoUploaded(true);
        handleClosePhotoCropperModal();
        }
    }

    const zoomIn = () => {
        cropperRef.current.zoomImage(1.1);
    }
    const zoomOut = () => {
        cropperRef.current.zoomImage(0.9091);
    }

    const handleClosePhotoCropperModal = () => {
        setShowPhotoCropperModal(false);
        setImage(null);
    }

	const items = [
		{
		  key: '1',
		  label: (
			<p style={{ display: 'block' }} onClick={() => handleDownloadClick('DOCX')}>
			  DOCX
			</p>
		  ),
		},
		{
		  key: '2',
		  label: (
			<p style={{ display: 'block' }} onClick={() => handleDownloadClick('PDF')}>
			  PDF
			</p>
		  ),
		}
	  ];

	return (
        <ConfigProvider theme={{ token: { colorBgContainer: '#fff' } }}>
            <div>
                <Helmet>
                    <title>Резюме сотрудника Enter Engineering</title>
                </Helmet>			
                <div className='dashboard'>
                    <NavBar />
                    <div className='dashboard-content'>
                        {loading && (<div className='loader-container'>
                            <Spin size="large"/>
                        </div>)}
						{showPhotoCropperModal && (
							<>
							<div className="modal-bg" onClick={handleClosePhotoCropperModal}></div>
							<div className="modal" >
							<h4 style={{ textAlign: "center", margin: "5px 0 15px" }}>Загрузка фото</h4><button type="button" className='btn' style={{ position: "absolute", top: "8px", right: "16px" }} onClick={handleClosePhotoCropperModal} ><CloseOutlined /></button>
							<input id='cropperUpload' hidden type="file" accept="image/*" onChange={handleImageUpload} />
							{image === null ? 
								(<label htmlFor='cropperUpload'>
								<div className='cropperUploadPanel'><h1>Нажмите для загрузки фото</h1></div>
								</label>) : 
								(<>
								<CustomCropper ref={cropperRef} src={image} />
								<div style={{ display: 'flex', flexWrap: 'wrap', margin: '5px 0 48px' }}>
									<Button shape="circle" onClick={() => cropperRef.current.rotateImage(-90)} icon={<RotateLeftOutlined />} style={{ marginRight: '10px' }} />
									<Button shape="circle" onClick={() => cropperRef.current.rotateImage(90)} icon={<RotateRightOutlined />} style={{ marginRight: '10px' }} />
									<Button shape="circle" onClick={() => cropperRef.current.flipImage(false, true)} icon={<VerticalAlignMiddleOutlined />} style={{ marginRight: '10px' }} />
									<Button shape="circle" onClick={() => cropperRef.current.flipImage(true, false)} icon={<VerticalAlignMiddleOutlined style={{transform: 'rotate(90deg)'}} />} style={{ marginRight: '10px' }} />
								</div>
								</>)
							}          
							
							<Button className='btn' type='secondary' style={{ position: "absolute", bottom: "8px", right: "16px", border: '1px solid #999' }} onClick={(handleCropImage)} >Подтвердить</Button>
							</div>
							</>
						)}
						{/* <div className='carousel-overlay'>
							<h1 className='center'>Выберите шаблон резюме {slideIndex}/2</h1>
							<button className='carousel-left-controller' onClick={previous}><LeftOutlined /></button>
							<button className='carousel-right-controller' onClick={next}><RightOutlined /></button>
						</div> */}
						<Dropdown menu={{ items }} placement="top">
							<Button type='primary' className='carousel-download-cv' size={'medium'} icon={<CloudDownloadOutlined /> }>Скачать резюме</Button>
						</Dropdown>
                        <Carousel ref={slider => {sliderRef = slider;}} infinite={false} dots={false} >
							<div className='carousel-item'>
                                <Template1
									formData={formData}
									educationData={educationData}
									languageData={languageData}
									computerSkillsData={computerSkillsData}
									employmentData={employmentData}
									setPhoto={setPhoto}
									setIsPhotoUploaded={setIsPhotoUploaded}
									setFormData={setFormData}
									open={open}
									setOpen={setOpen}
									setShowPhotoCropperModal={setShowPhotoCropperModal}
									registrationAddress={RegistrationAddress}
								/>
                            </div>
                            {/* <div className='carousel-item'>
                                <div className="container" id='form2print' ref={targetRef}>
                                    <div className='toPrint'>
                                        <img src={logo} style={{ height: '11.4mm', display: 'inline' }} />
                                        <i style={{ float: 'right', margin: '15px 35px 0 0', fontSize: '12pt' }}>Форма №2</i>
                                    </div>
                                    <PersonalInfo className='toPrint' formData={formData} />
                                    <EducationInfo className='toPrint' educationData={educationData} languageData={languageData} computerSkillsData={computerSkillsData} />
                                    <EmploymentInfo className='toPrint' employmentData={employmentData} />
                                    <RelativesInfo className='toPrint' relativesData={relativesData} registrationAddress={RegistrationAddress} residentialAddress={ResidenceAddress} />
                                    <AdditionalInfo className='toPrint' shiftWorkReady={ShiftMode} legalIssues={Prosecution} />
                                    <Disclaimer className='toPrint' />
                                </div>
                            </div>                             */}
                        </Carousel>
                    </div>
                </div>
            </div>
        </ConfigProvider>
	);
}

export default CV;
